import React, { useContext, useState } from "react";
import useDB from "../../hooks/useDB";
import Loading from "../../components/Loading";
import Error from "../../components/Error";
import { UserContext } from "../../../../Context";
import DrawContact from "./DrawContact";
import DrawTitles from "./DrawTitles";
import Pagination from "../../components/Pagination";
import Search from "../../components/Search";


export default function MyContacts(props) {

const {user} = useContext(UserContext)
const [page,setPage] = useState(0)
const [contacts, setContacts, error, loading] = useDB(`/sales-person/${user._id}`);
const [search,setSearch] = useState("")

if (loading) return <Loading />;
if (error) return <Error />;




return (
  <div>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems:"center" }}>
      <div>
        Contacts {page * 10} - {page * 10 + 10} of {contacts.length}
      </div>
      <Search
        search={search}
        setSearch={setSearch}
        size="small"
      />
      <Pagination
        page={page}
        setPage={setPage}
        end={contacts.length}
      />
    </div>
    <DrawTitles />
    {contacts.filter(c=> search ? filter(c,search.toLowerCase()) : true).slice(page * 10, page * 10 + 10).map((c) => (
      <DrawContact
        contact={c}
        key={c._id}
      />
    ))}
  </div>
);
}

function filter(c, search) {
  if (c.name && c.name.toLowerCase().includes(search)) return true
  if (c.phone && c.phone.includes(search)) return true
  if (c.notes && c.notes.toLowerCase().includes(search)) return true
  if (c.consultantNotes && c.consultantNotes.toLowerCase().includes(search)) return true;
  return false
}